<template>
  <v-autocomplete solo outlined flat light dense clearable hide-details
                  clear-icon="mdi-close"
                  style="pointer-events: auto; position: relative; width: 300px"
                  v-model="model"
                  :items="items"
                  :search-input.sync="searchFormatted"
                  :filter="v => v"
                  hide-no-data
                  hide-selected
                  item-text="postcode"
                  item-value="postcode"
                  label="Postcode Search"
                  :placeholder="CONFIG.config.customSearchText || 'Enter postcode to search'"
                  append-icon="mdi-search"
                  return-object
  >
    <template v-slot:item="{item}">
      <v-list-item @click="goToSelection(item)" class="pcode_item">
        <v-list-item-content>
          <v-list-item-title>{{item.postcode}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
  export default {
    name: 'PostcodeSearch',

    computed: {
      CONFIG () {
        return this.$store.getters.CONFIG
      },
      searchFormatted: {
        get() {
          return this.search;
        },
        set(v) {
          if (v) {
            this.search = v.replace(/ /g, '');
          }
        },
      },
    },

    watch: {
      search(val) {
        if (!val || val.length < 3) {
          this.searchResults = [];
          return;
        }

        this.sendRequest(val, this);
      },
    },

    methods: {
      createMarker (coords, item) {
        console.dir(item);
        if (this.marker){
          this.marker.destroy();
        }
        this.marker = new GOX.Marker(this.$MAP, coords, 'omnisearch-m1', {
          moveable: false,
          clickable: true,
          style: {
            fill: {
              color: '#FF0000',
            },
            text: {
              value: item.postcode,
              alignment: 'right',
              offsetX: 10,
              color: 'black',
              size: 14,
              weight: 'bold',
              stroke: {
                color: 'white',
                width: 4,
              },
            },
            symbol: {
              size: 5,
              fill: '#FF0000'
            },
            stroke: {
              color: 'white',
            },
          },
        });
      },
      goToSelection(item) {
        let mapEPSG = this.$MAP.getView()
          .getProjection()
          .getCode();
        let coords = GOX.Transform([item.lat, item.lng], 'EPSG:4326', mapEPSG);

        this.$MAP.setCenter(coords, 17);
        this.createMarker(coords, item)

      },
      sendRequest: _.throttle((val, this_) => {
        console.log(`POSTCODE: ${val}`);
        this_.$store.dispatch('pcodeSearch/SEARCH', val)
          .then((data) => {
            this_.items = data;
          });
      }),
    },

    data() {
      return {
        items: [],
        model: null,
        marker: null,
        search: null,
      };
    }
  };
</script>

<style lang="scss">
/*  .v-text-field--filled > .v-input__control > .v-input__slot {
    width: 280px !important;
    background-color: rgba(0, 0, 0, 0.6) !important;
  }*/
  .pcode_item {
    cursor: pointer;
    &:hover{
      background-color: #ccc;
    }
  }
</style>
